'use client';
import { accordionButtonClass, accordionContentClass, accordionSectionWrapperClass, accordionToggleIconClass, } from './Accordion.css';
import { SystemIcon } from '../Icon';
import classNames from 'classnames';
import React from 'react';
export const AccordionSection = ({ children, isOpen, onClick, onClose, onOpen, title, }) => {
    const handleClick = () => {
        if (isOpen) {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
        else {
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    return (React.createElement("section", { className: accordionSectionWrapperClass, "data-testid": "kda-accordion-section" },
        React.createElement("button", { className: accordionButtonClass, onClick: handleClick },
            title,
            React.createElement(SystemIcon.Close, { className: classNames(accordionToggleIconClass, {
                    isOpen,
                }), size: "xs" })),
        isOpen && children && (React.createElement("div", { className: accordionContentClass }, children))));
};
//# sourceMappingURL=AccordionSection.js.map